export interface FuelSupplierDetailsRecord {
  ID: number | undefined | null;
  FuelUpliftLTR: number | null;
  FuelUpliftKG: number | null | undefined;
  Density: number | null;
  FuelType: string | null;
  SAF: boolean | null;
  SAFBlend: number | null;
  LCEValue: number | null;
  EligibleForReduction: boolean | null;
  SupplierName: string | null;
  Price: number | null;
  Currency: string | null;
  ReceiptNo: string | null;
  No: string | null;
  IsNew: boolean;
  IsEditing: boolean;
  SourceTable: string;
  ParentId: number | null;
  IsChildRecord: boolean | null;
  AirportContractId: number | null;
  ScheduleDepartureDate: string | null;
  ActualDepartureDate: string | null;
  FlightNumber: number | null;
  CarrierCode: string | null;
  DepartureAirportIATA: string | null;
  ArrivalAirportIATA: string | null;
  LegNumber: number | null;
}
